<template>
  <div class="layout">

    <template v-if="redirectLoading">
      <Preloader absolute/>
      <div class="figures">
        <HelloFigure class="figure-top"/>
        <HelloFigure class="figure-bottom"/>
      </div>
    </template>

    <template v-else>
      <div class="figures">
        <HelloFigure v-if="showTopFigure" class="figure-top"/>
        <HelloFigure v-if="showBottomFigure" class="figure-bottom"/>
      </div>

      <AppNotice/>
      <GameMenu v-if="$route.name !== 'GameLogout'"/>
      <RouterView v-if="this.user"/>
    </template>
  </div>
</template>


<script>
import axios from 'axios';
import DateFilter from '@/filters/date.filter';
import { mapState, mapGetters } from 'vuex';

import Preloader from '@/components/game/Preloader';
import AppNotice from '@/components/game/AppNotice';
import GameMenu from '@/components/game/AppHeader/index.vue';
import HelloFigure from '@/components/game/HelloScreen/Figure';

export default {
  name: 'GameLayout',

  components: {
    Preloader,
    AppNotice,
    GameMenu,
    HelloFigure,
  },

  computed: {
    ...mapGetters([
      'user',
      'launch',
      'axiosOptions',
      'redirectLoading',
    ]),
    showTopFigure: ths => ths.$route.meta?.layout?.showTopFigure,
    showBottomFigure: ths => ths.$route.meta?.layout?.showBottomFigure,
  },

  watch: {
    '$store.getters.soundOfHistory'(soundOfHistory = {}) {
      this.$store.commit('setCurrentSoundId', soundOfHistory.id);
    },
  },

  async mounted() {
    // const { name, query } = this.$router.currentRoute;
    // if (name === 'ameProfile' && query.payload) return this.checkUser();
    this.checkLaunch();
    await this.$store.dispatch('checkGameToken');
    this.$store.dispatch('getUserData');
  },

  methods: {
    async checkLaunch() {
      if (this.launch && Math.ceil((Date.now() - +new Date(this.launch)) / 1000) <= 1800) return;
      try {
        const platform = this.getCurrentPlatform();
        const date = DateFilter(new Date(), 'datehour', true, true);
        await axios.put(`/api/analytics/launch`, { date, platform }, this.axiosOptions);
        this.$store.dispatch('createLaunch');
      } catch(err) {
        console.error(err);
      };
    },

    getCurrentPlatform() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        if (/Android/i.test(navigator.userAgent)) return 'android';
        if (/iPod|iPhone|iPad/i.test(navigator.userAgent)) return 'ios';
      } else {
        return 'web';
      };
    },
  },
};
</script>


<style lang="scss">
:root {
  --color-background: #E7DFCC;
  --color-secondary: #5446C6;
  --color-secondary-light: #B5AFFF;
  --color-primary: #F0724A;
  --color-light: #D9F855;
  --color-dark: #171717;
  --color-grey: #8D8D8D;
  --color-white: #fff;
  --color-error: #DA2F46;
  --color-warning: #CD9D00;
}
@font-face {
  font-family: 'Onder';
  font-style: normal;
  font-weight: 400;
  src: url('/fonts/Onder/Onder-Regular.ttf');
}
</style>

<style lang="scss" scoped>
$font-family: 'Montserrat', sans-serif;

.layout {
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-rows: 64px 1fr;
  padding: 0 20px;
  position: relative;
  max-width: 1000px;
  margin: 0 auto;
  box-sizing: content-box;

  &::after {
    content: "";
    position: fixed;
    inset: 0;
    z-index: -1;
    background-color: #E7DFCC;
  }

  @media screen and (min-width: 800px) and (orientation: landscape) {
    gap: 24px;
  }

  .figures {
    inset: 0;
    position: fixed;
    --max-width: 220px;

    & > .figure-top {
      top: calc(var(--max-width) * -0.4);
      left: calc(var(--max-width) * -0.25);
      rotate: -3deg;
    }

    & > .figure-bottom {
      bottom: calc(var(--max-width) * -0.3);
      right: calc(var(--max-width) * -0.2);
      rotate: 168deg;
    }

    @media screen and (min-width: 800px) and (orientation: landscape) {
      --max-width: 780px;
      --rotate-gradient: 210deg;

      & > .figure-top {
        top: calc(var(--max-width) * -0.45);
        left: calc(var(--max-width) * -0.3);
        rotate: -6deg;
      }
    }
  }

  & > main {
    width: calc(100vw - 40px);
    position: relative;
    z-index: 1;
    color: #F0724A;
    display: flex;
    flex-direction: column;
    max-width: 1000px;
    margin: 0 auto;
    padding: 12px 0 20px;
    gap: 12px;

    @media screen and (min-width: 800px) and (orientation: landscape) {
      gap: 24px;
    }
  }
}
</style>